const getEndTime = (resolution: string | number): number => {
    const now = Date.now();
    return now; // Возвращаем текущее время как конечную точку
};

const getStartTime = (resolution: string | number): number => {
    const now = Date.now();
    const oneMinute = 60 * 1000;
    const oneHour = 60 * oneMinute;
    const oneDay = 24 * oneHour;
    const oneWeek = 7 * oneDay;
    const oneMonth = 30 * oneDay;

    switch (resolution) {
        case '1':
        case '1m':
            return now - oneMinute;
        case '3':
        case '3m':
            return now - 3 * oneMinute;
        case '5':
        case '5m':
            return now - 5 * oneMinute;
        case '15':
        case '15m':
            return now - 15 * oneMinute;
        case '30':
        case '30m':
            return now - 30 * oneMinute;
        case '45':
        case '45m':
            return now - 45 * oneMinute;
        case '60':
        case '1h':
            return now - oneHour;
        case '120':
        case '2h':
            return now - 2 * oneHour;
        // case '180':
        // case '3h':
        //     return now - 3 * oneHour;
        case '240':
        case '4h':
            return now - 4 * oneHour;
        case 'D':
        case '1d':
            return now - oneDay;
        case 'W':
        case '1w':
            return now - oneWeek; // 1 неделя назад
        case 'M':
        case '1M':
            return now - 24 * oneMonth; // 24 месяца назад
        default:
            return now - oneHour; // По умолчанию 1 час назад
    }
};


export {
    getEndTime,
    getStartTime,
};
